import "../style/aboutme.css";
import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { SiGmail } from "react-icons/si";
import Footer from "./footer";
import { FiMail } from "react-icons/fi";
import ProjectSnapCarousel from "./projectSnapCarousel";

const aboutSections = [
  { id: "introduction", title: "Introduction" },
  { id: "interests", title: "Interests" },
];

function MobileSocialLinks() {
  return (
    <section className="about-mobile-socials" aria-label="Contact links">
      <a
        href="https://github.com/KimNG02"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visit my GitHub profile"
      >
        <FaGithub aria-hidden="true" />
      </a>
      <a href="mailto:kimmine03@gmail.com" aria-label="Send me an email">
        <SiGmail aria-hidden="true" />
      </a>
      <a
        href="https://www.linkedin.com/in/kim-nguyen-287473215/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visit my LinkedIn profile"
      >
        <FaLinkedin aria-hidden="true" />
      </a>
    </section>
  );
}

export default function AboutView() {
  const renderAboutSection = (section) => {
    if (section.id === "introduction") {
      return (
        <section className="about-hero">
          <div className="about-text">
            <h1>Kim Nguyen</h1>
            <div className="lead-wrapper-1">
              <img src="/line.png" alt="" className="line" />
              <p className="lead-1">
                <span className="text-highlight">
                  {" "}
                  Hello! I'm Kim and I’m a Machine Learning{" "}
                </span>
                student at KTH. I’m a goal achiever with a never-give-up
                mindset. I have a strong interest in computer science, data
                science, and software development.
              </p>
            </div>
          </div>

          <div className="about-photo">
            <img className="scribble" src="/scribble.png" alt="" />
            <figure className="polaroid-1">
              <img src="/kim_selfie.jpeg" alt="Kim Nguyen" />
            </figure>
          </div>
        </section>
      );
    }

    if (section.id === "interests") {
      return (
        <section className="lead-wrapper-2">
          <div className="about-photo">
            <figure className="polaroid-2">
              <img src="/kim_tedtalk.jpeg" alt="Kim Nguyen giving a talk" />
            </figure>
          </div>

          <p className="lead-2">
            <span className="text-highlight">
              {" "}
              I’m a creative and curious person{" "}
            </span>
            who enjoys drawing, painting, meeting new people, attending events,
            and staying active at the gym. Outside of tech, I find energy in
            social connections, new experiences, and trying new things.
          </p>
        </section>
      );
    }

    return null;
  };

  return (
    <main className="about-page">
      <ProjectSnapCarousel
        items={aboutSections}
        ariaLabel="About me sections"
        className="about-snap-carousel"
        footer={
          <div className="about-page-footer">
            <MobileSocialLinks />
            <Footer />
          </div>
        }
        renderItem={renderAboutSection}
      />

      {/*
      <section className="cta">
        <h2>Let’s get in touch ⇒</h2>
        <div className="cta-actions">
          <a className="btn-gradient" href="mailto:kimmine03@gmail.com">
            <FiMail className="contact-me-icon" />
            <span className="btn-text">Contact me</span>
          </a>

          <div className="contact-icons-extra">
            <a
              href="https://github.com/KimNG02"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
            >
              <FaGithub className="github-icon" />
            </a>
            <a href="mailto:kimmine03@gmail.com" aria-label="Email">
              <SiGmail className="mail-icon" />
            </a>
            <a
              href="https://www.linkedin.com/in/kim-nguyen-287473215/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedin className="linkedin-icon" />
            </a>
          </div>
        </div>
      </section>
      */}
    </main>
  );
}
